import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { JSONResponse, UserService } from '../user.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NumericStringMap } from '../models';

@Component({
	selector: 'app-login',
	standalone: true,
	templateUrl: './login.html',
	styleUrls: ['./login.scss'],
	imports: [FormsModule, CommonModule],	
	//on push change cetection to optimize performance
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {
	email = '';
	password = '';
	errorMessage = '';

	public language : number = 1; //default to English


	public string_data = {
		LogIn: { 1: "Log In", 2: "ログイン" } as NumericStringMap,
		Email: { 1: "Email", 2: "メール" } as NumericStringMap,
		Password: { 1: "Password", 2: "パスワード" } as NumericStringMap,
		Submit: { 1: "Submit", 2: "送信" } as NumericStringMap,
		ForgotPassword: { 1: "Forgot Password?", 2: "パスワードをお忘れですか？" } as NumericStringMap,
		LanguageEnglish: { 1: "English", 2: "英語" } as NumericStringMap,
		LanguageJapanese: { 1: "Japanese", 2: "日本語" } as NumericStringMap,
	}
	
	constructor(private userService: UserService, protected _cd: ChangeDetectorRef, protected _router: Router) {
		effect(() => {
			const tenant = this.userService.currentTennant();
			this.language = tenant ? tenant.Language : 2;
			this._cd.detectChanges();
		});
	}

	ngOnInit(): void {
		
			if (typeof window !== 'undefined' && window.location && window.location.search) {
				const params = new URLSearchParams(window.location.search);
				const langParam = params.get('language');
				if (langParam) {
					console.log( 'Language parameter found in URL:', langParam);
					switch (langParam.toLowerCase()) {
						case '1':
						case 'en':
							this.language = 1;
							break;
						case '2':
						case 'ja':
							this.language = 2;
							break;
						default:
							this.language = 1; //default to English
					}
					this._cd.detectChanges();
				}
			}	
	}

	
	async onLogin() {
		//ensure email and password are provided
		if (!this.email || !this.password) {
			this.errorMessage = 'Please enter both email and password';
			return;
		}

		let resp = await this.userService.login(this.email, this.password) as JSONResponse;
		console.log('login response', resp);
		if (!resp.success) {
			this.errorMessage = resp.error || 'Login failed';
			this._cd.markForCheck(); //manually trigger change detection
			return;
		}

		else{
			this.errorMessage = '';
			this._cd.markForCheck(); //manually trigger change detection
			this._router.navigate(['/home']);
			
		}
		//call the login method from the user service
	}

	resetError() {
		this.errorMessage = '';
		this._cd.markForCheck(); //manually trigger change detection
	}

	setLanguage(lang: number) {
		this.language = lang;
		this.userService.setLanguage(lang);
		this._cd.detectChanges(); //manually trigger change detection
	}
}